module.exports = __webpack_public_path__ + "img/questionnaire-example.06589f33.png";